//import { useLingui } from '@lingui/react';
import { useMutation } from '@apollo/client';

import { useEffect } from 'react';
import { styled } from 'styled-components';
import { GQL_UPDATE_TRACKING_THEMATIQUE } from '~/gql/tracking-thematique/tracking-thematique';
import useInactivityDetect from '~/helpers/hooks/activity-detect';
import useSoundAudio from '~/helpers/hooks/soundAudio';
import { useTimer } from '~/helpers/hooks/timer';
import useConnectionStore from '~/helpers/store/connection/connection';
import { changeActivityOrder } from '~/pages/components/game/activities-forms/utils';

import { DialogItem } from '~/pages/components/ui/dialog-item';
import { TActivity } from '~/utils/airtable/types/types';
import { renderFullPath } from '~/utils/common/utils';

type IProps = {
  currentActivity: TActivity;
  nextActivity: () => void;
};

function Dialog({ currentActivity, nextActivity }: IProps) {
  //const { i18n } = useLingui();
  const { time, start, stop, clear } = useTimer();
  const { currentTrackingThematiqueId, currentTrackings, setCurrentTrackings } =
    useConnectionStore();
  const isActive = useInactivityDetect({ timeout: 5000 });

  const { playSound } = useSoundAudio();

  useEffect(() => {
    if (!isActive) {
      stop();
    } else {
      start();
    }
  }, [isActive]);

  const [updateTrackingThematique] = useMutation(
    GQL_UPDATE_TRACKING_THEMATIQUE
  );

  useEffect(() => {
    start();

    if (currentTrackingThematiqueId) {
      setCurrentTrackings(
        changeActivityOrder(
          currentTrackingThematiqueId,
          currentActivity.order,
          currentTrackings
        )
      );
    }
  }, [currentActivity]);

  /*
      try {
      //
    } finally {
      //
    }
  */
  async function handleNext() {
    stop();
    try {
      if (currentTrackingThematiqueId) {
        await updateTrackingThematique({
          variables: { id: currentTrackingThematiqueId, time: time },
        });
      }
    } finally {
      clear();
      playSound('click');
      nextActivity();
    }
  }

  return (
    <Container
      $background={renderFullPath(currentActivity.background)}
      onClick={handleNext}
    >
      <img
        src={renderFullPath(currentActivity.characterImg)}
        alt="personnage"
      />

      <DialogItem
        text={currentActivity.text}
        autor={currentActivity.characterName}
      />
    </Container>
  );
}

export default Dialog;

const Container = styled.div<{ $background?: string }>`
  align-items: center;
  background-image: ${({ $background }) =>
    $background ? `url('${$background}')` : 'none'};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  position: relative;
  width: 100%;

  img {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    height: auto;
    pointer-events: none;
    width: 100%;
    user-select: none;
  }
`;
